import { SubKelompokAnggaranApi } from "api";
import { ActionButton, Input, SelectSearch, TextArea } from "components";
import { useFormikContext } from "formik";
import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";

export const ModalAction = ({ setModalConfig, modalConfig, dropdown }) => {
  const [isNomorLoading, setIsNomorLoading] = useState(false);
  const {
    values,
    handleChange,
    setValues,
    handleSubmit,
    isSubmitting,
    errors,
    touched,
    resetForm,
  } = useFormikContext();

  const getNomorHandler = () => {
    setIsNomorLoading(true);

    SubKelompokAnggaranApi.getKode()
      .then(({ data }) => {
        const kode = data.data;
        if (modalConfig.type === "add") {
          setValues({
            ...values,
            kodeSubKelompok: kode,
          });
        }
      })
      .catch(() => {
        setValues({
          ...values,
          kodeSubKelompok: "",
        });
        window.alert("Nomor gagal dimuat");
      })
      .finally(() => {
        setIsNomorLoading(false);
      });
  };

  useEffect(() => {
    getNomorHandler();

    return () => {
      setIsNomorLoading(false);
    };
  }, []);

  return (
    <div>
      <Modal
        show={modalConfig?.show}
        onHide={() => setModalConfig({ data: {}, type: "add", show: false })}
      >
        <form onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            {modalConfig.type === "edit" ? "Ubah" : "Tambah"} Sub Kelompok
            Anggaran
          </Modal.Header>
          <Modal.Body>
            <Input
              label="Kode Sub Kelompok Anggaran"
              placeholder="Masukan kode sub kelompok anggaran"
              name="kodeSubKelompok"
              value={
                isNomorLoading ? "Memuat data ..." : values?.kodeSubKelompok
              }
              readOnly
            />
            <Input
              label="Nama Sub Kelompok Anggaran"
              placeholder="Masukan nama sub kelompok anggaran"
              name="namaSubKelompok"
              value={values?.namaSubKelompok}
              onChange={handleChange}
              error={Boolean(errors.namaSubKelompok) && touched.namaSubKelompok}
              errorText={
                Boolean(errors.namaSubKelompok) &&
                touched.namaSubKelompok &&
                errors.namaSubKelompok
              }
            />

            <SelectSearch
              label="Kelompok Anggaran"
              placeholder="Pilih kelompok anggaran"
              option={dropdown}
              loading={isNomorLoading}
              onChange={(val) =>
                setValues({
                  ...values,
                  idKelompok: val?.value,
                  namaKelompok: val?.label,
                })
              }
              defaultValue={
                values?.idKelompok && {
                  value: values.idKelompok,
                  label: values.namaKelompok,
                }
              }
              error={Boolean(errors.idKelompok) && touched.idKelompok}
              errorText={
                Boolean(errors.idKelompok) &&
                touched.idKelompok &&
                errors.idKelompok
              }
            />
            <TextArea
              label="Keterangan"
              placeholder="Masukan keterangan"
              name="keterangan"
              rows="4"
              value={values?.keterangan}
              onChange={handleChange}
            />
          </Modal.Body>
          <Modal.Footer>
            {/* <ActionButton
              text="Batal"
              variant="outline-secondary"
              size="sm"
              onClick={() =>
                resetForm({
                  values: {
                    keterangan: "",
                    idKelompok: "",
                    namaSubKelompok: "",
                    idKelompok: "",
                    namaKelompok: "",
                  },
                })
              }
            /> */}
            <ActionButton
              text={modalConfig.type === "edit" ? "Ubah" : "Simpan"}
              type="submit"
              size="sm"
              variant={modalConfig.type === "edit" ? "success" : "primary"}
              loading={isSubmitting}
            />
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
};
